import { AutogenModelDrayRate, AutogenRowDrayRate } from "./autogen/AutogenModelDrayRate";

export class ModelDrayRate extends AutogenModelDrayRate<RowDrayRate> {
	constructor() {
		super(RowDrayRate);
	}
}

export class RowDrayRate extends AutogenRowDrayRate {
}